import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function ResultsCollageSection() {
  return <Section background="white" data-id="element-583">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-584">
        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative" data-id="element-585">
          <div className="rounded-3xl overflow-hidden shadow-2xl" data-id="element-586">
            <img src="https://cdn.magicpatterns.com/uploads/7Z4Gxf5qnqXDDk2DBHzDTW/imgi_9_1768343228-ChatGPT_Image_Jan_132C_20262C_11_26_43_PM.png" alt="StingFit - Personas reales, resultados reales" className="w-full object-cover" data-id="element-587" />
          </div>
          {/* Floating badge */}
          <div className="absolute -top-4 -right-4 bg-[#D4AF37] text-white rounded-2xl px-4 py-3 shadow-xl text-center" data-id="element-588">
            <p className="text-2xl font-black leading-none" data-id="element-589">+10K</p>
            <p className="text-xs font-bold mt-0.5" data-id="element-590">Transformaciones</p>
          </div>
        </motion.div>

        {/* Content */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} data-id="element-591">
          <div className="inline-flex items-center gap-2 bg-amber-50 text-amber-700 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-6" data-id="element-592">
            <span className="w-2 h-2 bg-amber-500 rounded-full animate-pulse" data-id="element-593"></span>
            Comunidad StingFit
          </div>

          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6 leading-tight" data-id="element-594">
            Personas reales.{' '}
            <span className="text-[#D4AF37]" data-id="element-595">Resultados reales.</span>
            <br data-id="element-596" />
            Sin filtros.
          </h2>

          <p className="text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-597">
            Cada foto en nuestra comunidad es de una persona real que decidió
            apostar por StingFit. No hay trucos, no hay Photoshop. Solo la
            ciencia del veneno de abeja haciendo su trabajo.
          </p>

          <div className="space-y-4 mb-8" data-id="element-598">
            <div className="flex items-start gap-3" data-id="element-599">
              <CheckCircle2 className="w-5 h-5 text-[#2D5016] flex-shrink-0 mt-0.5" data-id="element-600" />
              <div data-id="element-601">
                <p className="font-bold text-gray-900" data-id="element-602">
                  Resultados en todas las edades
                </p>
                <p className="text-sm text-gray-500" data-id="element-603">
                  Desde los 25 hasta los 65 años, StingFit funciona.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-604">
              <CheckCircle2 className="w-5 h-5 text-[#2D5016] flex-shrink-0 mt-0.5" data-id="element-605" />
              <div data-id="element-606">
                <p className="font-bold text-gray-900" data-id="element-607">
                  Para hombres y mujeres
                </p>
                <p className="text-sm text-gray-500" data-id="element-608">
                  La grasa abdominal no discrimina, y StingFit tampoco.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-609">
              <CheckCircle2 className="w-5 h-5 text-[#2D5016] flex-shrink-0 mt-0.5" data-id="element-610" />
              <div data-id="element-611">
                <p className="font-bold text-gray-900" data-id="element-612">
                  Sin cambiar tu estilo de vida
                </p>
                <p className="text-sm text-gray-500" data-id="element-613">
                  Un parche al día mientras duermes. Así de simple.
                </p>
              </div>
            </div>
          </div>

          <Button size="lg" className="group shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-614">
            <span className="flex items-center font-bold" data-id="element-615">
              UNIRME A LA COMUNIDAD
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-616" />
            </span>
          </Button>
          <p className="text-xs text-green-700 font-bold mt-3" data-id="element-617">
            💰 Pago contra entrega en la puerta de tu casa
          </p>
        </motion.div>
      </div>
    </Section>;
}